<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

#app {
    font-family: "sbold";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue